import { toast } from 'react-toastify';
import { currency } from '@utils';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import apiForluz from './api';

export class EmprestimoService {
  getLayoutPaginaEmprestimo = async (Identificador) => {
    const response = await apiForluz.get('ObterLayoutPaginaEmprestimo', {
      params: {
        Identificador,
      },
    });

    return response.data.results[0].ConteudoTexto;
  };

  obterContratos = async ({ matricula, token }) => {
    try {
      const response = await apiForluz.get('ObterContratosFormatado', {
        params: {
          matricula,
          token,
        },
      });

      return response;
    } catch (err) {
      return [];
    }
  };

  obterLimiteEmprestimo = async ({ matricula, token }) => {
    try {
      const response = await apiForluz.get(
        'ObterCalculoLimiteMaximoFormatado',
        {
          params: {
            matricula,
            token,
          },
        }
      );

      return response.data[0];
    } catch (err) {
      return {
        E_IDADE: '0',
        E_PRAZO_MAX_REAL: '0',
        E_PERC_MARGEM: '0',
        E_PERC_RESERVA: '0',
        E_INADIM: 'N',
        E_CARENCIA: 'N',
        E_FATORCORR_SLD: '0',
        E_TXJRS_AA: '0',
        E_TXJRS_AM: '0',
        E_TXSEG_AM: '0',
        E_VLRPREST_RUBF: '0',
        E_VLRCOMPR_SIM: '0',
        E_VLRCOMPR_EXT: '0',
        E_VLRCOMPR_AVAL: '0',
        E_VLRPREST_MAX: '0',
        E_IND_AM: '0',
        E_IND_JRS: '0',
        E_IND_SEG: '0',
        E_IND_FINAL: '0',
        E_LIM_MIN: '0',
        E_LIM_MAX: '0',
        T_SLDDEV: '0',
        T_BLOQUEIO: '',
        ERROR_NUMBER: '000',
        ERROR_MESSAGE: '',
        ERRO_SHAREPOINT: 'Ocorreu um erro. Por favor tentar mais tarde',
      };
    }
  };

  obterConfigsEmprestimo = async () => {
    try {
      const response = await apiForluz.get('ObterConfiguracoesEmprestimo');

      return response.data;
    } catch (err) {
      return [];
    }
  };

  obterValoresEmprestimoInicial = async ({
    matricula,
    token,
    valor,
    parcelas,
  }) => {
    try {
      const response = await apiForluz.get('ObterSimulacaoEmprestimoOpcoes', {
        params: {
          matricula,
          token,
          valor,
          prazo: parcelas,
        },
      });
      const dados =
        response.data[0].response['SOAP:Envelope']['SOAP:Body'][0][
          'ns1:MT_SimulacaoFluxoEmprestimo_Response'
        ][0].ES_SIMULACAO[0];

      const erro =
        response.data[0].response['SOAP:Envelope']['SOAP:Body'][0][
          'ns1:MT_SimulacaoFluxoEmprestimo_Response'
        ][0].E_MSG_ERRO[0].MESSAGE[0];

      return { ...dados, ...erro };
    } catch (err) {
      return {};
    }
  };

  obterValoresEmprestimo = async ({ matricula, token, valor, parcelas }) => {
    try {
      const response = await apiForluz.get('ObterSimulacaoEmprestimo', {
        params: {
          matricula,
          token,
          valor,
          prazo: parcelas,
        },
      });
      const dados =
        response.data[0].response['SOAP:Envelope']['SOAP:Body'][0][
          'ns1:MT_SimulacaoFluxoEmprestimo_Response'
        ][0].ES_SIMULACAO[0];

      const erro =
        response.data[0].response['SOAP:Envelope']['SOAP:Body'][0][
          'ns1:MT_SimulacaoFluxoEmprestimo_Response'
        ][0].E_MSG_ERRO[0].MESSAGE[0];

      return { ...dados, ...erro };
    } catch (err) {
      return {};
    }
  };

  obterCalendario = async () => {
    try {
      const response = await apiForluz.get('ObterCalendario');

      return Object.values(response.data).sort(
        (a, b) => a[0].Ordem - b[0].Ordem
      );
    } catch (e) {
      return [];
    }
  };

  gerarPDFParcelasEmprestimo = async ({
    matricula,
    token,
    nome,
    parcelas,
    nContrato,
  }) => {
    try {
      const response = await apiForluz.post('GerarPdfParcelasEmprestimo', {
        matricula,
        token,
        nome,
        parcelas,
        nContrato,
      });

      return response.data;
    } catch (e) {
      toast.error('Erro ao gerar pdf de parcelas de empréstimo');
      return null;
    }
  };

  gerarPDFSimulacaoEmprestimo = async (data) => {
    try {
      const response = await apiForluz.post(
        'GerarPdfSimulacaoEmprestimo',
        data
      );

      return response.data;
    } catch (e) {
      toast.error('Erro ao gerar pdf de simulação de empréstimo');
      return null;
    }
  };

  gerarPDFSimulacaoEmprestimoSign = async (data) => {
    try {
      const response = await apiForluz.post(
        'GerarPdfSimulacaoEmprestimoSign',
        data
      );

      return response.data;
    } catch (e) {
      toast.error(
        'Erro ao gerar pdf de simulação de empréstimo na plataforma digital'
      );
      return null;
    }
  };

  obterFAQEmprestimos = async () => {
    try {
      const response = await apiForluz.get('ObterFAQEmprestimo');

      return response.data;
    } catch (e) {
      toast.error('Erro ao obter FAQ de empréstimos');
      return [];
    }
  };

  obterRegrasGerais = async () => {
    try {
      const response = (await apiForluz.get('ObterDadosRegrasGerais')).data;

      return {
        ...response,
        DataLimiteIndividual: format(
          new Date(response.DataLimiteIndividual),
          'dd/MM/yyyy'
        ),
        DataLimiteInicial: format(
          new Date(response.DataLimiteInicial),
          'dd/MM/yyyy'
        ),
        DataLimiteFinal: format(
          new Date(response.DataLimiteFinal),
          'dd/MM/yyyy'
        ),
        DataPrestacao: format(
          new Date(response.DataPrestacao),
          "MMMM 'de' yyyy",
          { locale: ptBR }
        ),
      };
    } catch (e) {
      toast.error('Erro ao obter regras gerais');

      return '';
    }
  };

  obterURLPDFRegulamentoEmprestimo = async () => {
    try {
      const response = await apiForluz.get('ObterRegulamentoEmprestimo');

      return response.data.results[0].URL;
    } catch (e) {
      toast.error('Erro ao obter PDF Regulamento Empréstimo');

      return '';
    }
  };

  obterAssuntosFaleConosco = async () => {
    try {
      const response = await apiForluz.get('ObterAssuntosFaleConosco');

      return response.data;
    } catch (e) {
      return [];
    }
  };

  obterDadosImpostoDeRenda = async (matricula, token) => {
    try {
      const response = await apiForluz.get('ObterValorIREmprestimo', {
        params: {
          matricula,
          token,
        },
      });

      return {
        penultimoSaldoDevedor: currency(response.data.penultimoSaldoDevedor),
        penultimoValorTotalPago: currency(
          response.data.penultimoValorTotalPago
        ),
        ultimoSaldoDevedor: currency(response.data.ultimoSaldoDevedor),
        ultimoValorTotalPago: currency(response.data.ultimoValorTotalPago),
      };
    } catch (e) {
      return {
        penultimoSaldoDevedor: '',
        penultimoValorTotalPago: '',
        ultimoSaldoDevedor: '',
        ultimoValorTotalPago: '',
      };
    }
  };

  obterDatasQuitação = async () => {
    try {
      const response = await apiForluz.get('ObterLimiteQuitacao');

      return response.data;
    } catch (e) {
      return {
        DataInicial: '',
        DataFinal: '',
      };
    }
  };

  obterCalculoAmortizacao = async ({
    matricula,
    contrato,
    valor,
    data = '',
    token,
  }) => {
    try {
      const response = await apiForluz.get('CalcularAmortizacao', {
        params: {
          matricula,
          contrato,
          valor,
          data,
          token,
        },
      });

      return response.data?.valor;
    } catch (e) {
      return '';
    }
  };

  obterCalcularAntecipacaoCarencia = async ({
    matricula,
    contrato,
    parcela,
    token,
  }) => {
    try {
      const response = await apiForluz.get('CalcularAntecipacaoCarencia', {
        params: {
          matricula,
          contrato,
          parcela,
          token,
        },
      });

      return response.data?.valor;
    } catch (e) {
      return '';
    }
  };

  obterCalcularAntecipacao = async ({ matricula, contrato, valor, token }) => {
    try {
      const response = await apiForluz.get('CalcularAntecipacao', {
        params: {
          matricula,
          contrato,
          valor,
          token,
        },
      });

      return response.data?.valor;
    } catch (e) {
      return '';
    }
  };

  verificaBloqueioEmprestimo = async ({ matricula, token }) => {
    try {
      const response = await apiForluz.get('VerificarBloqueioEmprestimo', {
        params: {
          matricula,
          token,
        },
      });

      return response.data?.descricao;
    } catch (e) {
      return '';
    }
  };

  validaEmprestimoManual = async (matricula) => {
    try {
      const response = await apiForluz.get('ValidaMatriculaAcessoAntigo', {
        params: {
          matricula,
        },
      });

      return response.data;
    } catch (e) {
      return false;
    }
  };

  emitirBoletoEmprestimo = async (params) => {
    try {
      const response = await apiForluz.get('EmitirBoletoEmprestimo', {
        params,
        responseType: 'arraybuffer',
      });

      return response.data;
    } catch (error) {
      toast.error(
        'Erro ao gerar o boleto, favor entrar em contato com o atendimento'
      );
      return null;
    }
  };
}
